import React, { useState } from "react";

import { Link } from "react-router-dom";

import COLORS from "../../../../../core/utils/colors";
import PieCard from "../../../../../core/components/recharts/pie";

import { PageHeader, Divider, Row, Col, Table } from "antd";

const columns = [
    {
        title: "Month",
        dataIndex: "name",
        key: "name",
    },
    {
        title: "# of Jobs",
        dataIndex: "Jobs",
        key: "Jobs",
    },
    {
        title: "# of Words",
        dataIndex: "Words",
        key: "Words",
    },
];

const Show = (props) => {
    const goBack = () => props.history.goBack();

    const dataClient = props.data.stats.jobsByClient;
    const dataWordsClient = props.data.stats.wordsByClient;
    const dataProject = props.data.stats.jobsByProject;
    const dataWordsProject = props.data.stats.wordsByProject;
    const dataPointOfSale = props.data.stats.jobsByPointOfSale;
    const dataWordsPointOfSale = props.data.stats.wordsByPointOfSale;

    return (
        <>
            <PageHeader ghost={false} onBack={goBack} title="Jobs Period" subTitle={props.data.stats.name} />
            <Divider />

            <Row gutter={8}>
                <Col span={12}>
                    <PieCard title="Jobs by Point Of Sale" label="Jobs" data={dataPointOfSale} />
                </Col>
                <Col span={12}>
                    <PieCard title="Words by Point Of Sale" label="Words" data={dataWordsPointOfSale} />
                </Col>

                <Divider />
                <Col span={12}>
                    <PieCard title="Jobs by Project" label="Jobs" data={dataProject} />
                </Col>
                <Col span={12}>
                    <PieCard title="Words by Project" label="Words" data={dataWordsProject} />
                </Col>
                <Divider />
                <Col span={12}>
                    <PieCard title="Jobs by Client" label="Jobs" data={dataClient} />
                </Col>
                <Col span={12}>
                    <PieCard title="Words by Client" label="Words" data={dataWordsClient} />
                </Col>

                <Divider />
            </Row>
        </>
    );
};

export default Show;
